import { Field, FormTheme } from '@kanda-libs/ks-component-ts';
import { FILTERABLE_SELECT_FIELD_PROPS } from './constants';
import useFilterableSelect from './useFilterableSelect';

const BusinessConfigFilterableSelect: React.FunctionComponent = function () {
  const { options } = useFilterableSelect();
  return (
    <FormTheme variant="streamline">
      <Field.FilterableSelect
        options={options}
        {...FILTERABLE_SELECT_FIELD_PROPS}
      />
    </FormTheme>
  );
};

export default BusinessConfigFilterableSelect;
